import crossFetch from 'cross-fetch';
import { ResponseError } from '@backstage/errors';
import { Repo } from '../types';
import { ReposApi } from './ReposApi';

// these are isomorphic types that don't require @backstage/core-plugin-api
type DiscoveryApi = { getBaseUrl(pluginId: string): Promise<string> };
type FetchApi = { fetch: typeof fetch };

export class ReposClient implements ReposApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  public constructor(deps: {
    discoveryApi: DiscoveryApi;
    fetchApi?: FetchApi;
  }) {
    const { discoveryApi, fetchApi } = deps;
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi ?? { fetch: crossFetch };
  }

  public async getRepos() {
    const baseUrl = await this.getBaseUrl();
    const response = await this.fetchApi.fetch(`${baseUrl}/repos`);
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    const results: Repo[] = await response.json();
    return results;
  }

  private async getBaseUrl() {
    return this.discoveryApi.getBaseUrl('code-search');
  }
}
